import * as React from 'react';
import {TypeImplementation} from '@packages/systems/wfdl';
import {updateExpressionAction} from '@packages/systems/ExpressionEditor-utils';
import {
  TUnion,
  TEmptyRecord,
  EUnion,
  ERecord,
} from '@packages/systems/wfdl-ast';
import {Select, Option} from '@packages/systems/design-system/WebflowSelect';
import {LogicLabel} from '@packages/systems/flows/shared';
import {styledDiv} from '@packages/utilities/styled';

import {
  ContextualExpressions,
  stripAnn,
} from '@packages/utilities/contextual-expression';

const itemStatusType = TUnion({
  current: TEmptyRecord,
  draft: TEmptyRecord,
  publish: TEmptyRecord,
  staged: TEmptyRecord,
  archived: TEmptyRecord,
});

const itemStatusOptions = [
  {id: 'current', label: 'Keep current status'},
  {id: 'draft', label: 'Draft'},
  {id: 'publish', label: 'Live item'},
  {id: 'staged', label: 'Staged for publish'},
  {id: 'archived', label: 'Archive'},
];

/**
 * Union type for choosing the status of an item for Update CMS item
 */
export const UpdateItemStatus = TypeImplementation.Alias({
  type: itemStatusType,
  render: function UpdateItemStatus({expr, dispatch}) {
    const strippedExpr = stripAnn(expr);
    const union = ContextualExpressions.getUnion(strippedExpr);
    const tag = union ? union.tag : 'current';

    const onStatusChange = React.useCallback(
      // @ts-expect-error - TS7006 - Parameter 'id' implicitly has an 'any' type.
      (id) => {
        dispatch(updateExpressionAction(EUnion({tag: id, value: ERecord({})})));
      },
      [dispatch]
    );

    return (
      <>
        <Divider />
        <LogicLabel label="Item status" htmlFor="flow-update-item-status" />
        <Select
          id="flow-update-item-status"
          data-automation-id="flow-update-item-status"
          onChange={onStatusChange}
          value={tag}
          aria-label={`Update item status: ${tag}`}
        >
          {itemStatusOptions.map(({id, label}) => {
            return <Option key={id} value={id} label={label} />;
          })}
        </Select>
      </>
    );
  },
});

const Divider = styledDiv(({theme: {gutters, colors}}) => ({
  height: 1,
  backgroundColor: colors.backgroundDeep,
  width: `calc(100% + ${gutters.x8 * 2 + gutters.x4}px)`,
  marginLeft: -gutters.x8 - gutters.x4 / 2,
}));
